import { Budget } from "@/manager/budget/models/budget.model";
import { Purchase } from "@/clickbuy/purchase/models/purchase.model";
import { SaleInfo } from "@/clickbuy/purchase/models/sale-info.model";
import { Companion } from "@/clickbuy/purchase/models/companion.model";
import { Note } from "@/manager/convocation/note.model";
import { TypeOfProduct } from "@/manager/product/models/product.model";
import { DelegationInterface } from "@/shared/interfaces/delegation.interface";
import { ConvocationInterface } from "@/manager/convocation/convocation.model";
import {
  ProductInterface,
  TypeOfPrice
} from "@/manager/product/models/product.model";
import { FeeInterface } from "@/clickbuy/purchase/models/fee.interface";
import { SwitchActiveColor } from "@/shared/components/button-switch.component.vue";

export interface State {
  list: Purchase[];
  purchaseTagList: Array<Record<string, string>>;
  selectedClient: any;
  internalBussinessSelected: any;
  saleInfoList: SaleInfo[];
  companionList: Companion[];
  convocationBalance: number;
  addingUser: boolean;
  currentPurchase: Purchase;
  currentPurchaseTypeOfProduct: TypeOfProduct;
  convocationNoteList: Note[];
  budgetList: Budget[];
  budgetNoteList: Note[];
  purchaseNoteList: Note[];
  budgetCommentNoteList: Note[];
  allowEditBudget: boolean;
  currentBudget: Budget;
  allowShowBudgetFees: boolean;
  currentBudgetAcceptance: Budget;
  currentBudgetAcceptanceDelegationList: DelegationInterface[];
  currentBudgetAcceptanceConvocationList: ConvocationInterface[];
  currentBudgetAcceptanceProductList: ProductInterface[];
  currentBudgetAcceptanceSelectedConvocations: string[];
  currentBudgetAcceptancePreviousSelectedConvocations: string[];
  currentBudgetAcceptanceMessageInfo: string;
  acceptanceFieldError: any;
  acceptanceRequestTimeout: number;
  feeList: FeeInterface[];
  userMoneyFlow: number;
  typeOfPrice: TypeOfPrice;
  currentPurchaseLoading: boolean;
}

export const state: State = {
  list: [],
  purchaseTagList: [],
  selectedClient: null,
  internalBussinessSelected: {
    id: -1,
    name: "Seleccione",
    requestName: "_",
    activeColor: SwitchActiveColor.Primary
  },
  saleInfoList: [],
  companionList: [],
  convocationBalance: 0,
  addingUser: false,
  currentPurchase: new Purchase(),
  currentPurchaseTypeOfProduct: TypeOfProduct.Course,
  convocationNoteList: [],
  budgetList: [],
  budgetNoteList: [],
  purchaseNoteList: [],
  budgetCommentNoteList: [],
  allowEditBudget: true,
  currentBudget: new Budget(),
  allowShowBudgetFees: true,
  currentBudgetAcceptance: new Budget(),
  currentBudgetAcceptanceDelegationList: [],
  currentBudgetAcceptanceConvocationList: [],
  currentBudgetAcceptanceProductList: [],
  currentBudgetAcceptanceSelectedConvocations: [],
  currentBudgetAcceptancePreviousSelectedConvocations: [],
  currentBudgetAcceptanceMessageInfo: "",
  acceptanceFieldError: {},
  acceptanceRequestTimeout: 0,
  feeList: [],
  userMoneyFlow: 0,
  typeOfPrice: TypeOfPrice.Course,
  currentPurchaseLoading: false
};
